export default __webpack_public_path__ + "static/media/902.5b6e9a0d.png";